import React, { useState } from "react";
import {
  defaultLanguage,
  getAnalyticsDevice,
  setCookiesBrowser,
  getAnalyticsUniqueId,
  sendVisit
} from "../../helper/utility";
import { language } from "../../languageProvider/language/language";
import { serverResponse } from "../../util/fakeServer";
import { visit } from "../../services/analytics.services";
import {
  isIPad13,
  isMobileOnly,
  isTablet,
  isBrowser as isDesktop
} from "react-device-detect";

const CookieConsentBannerIP = () => {
  const [clicked, setClicked] = useState(false);

  const visitAnaliticsVisit = () => {
    visit({
      id_cliente: serverResponse.config.client_id,
      id_insegna: serverResponse.config.signboard_id,
      id_utente: serverResponse.config.release_id,
      id_volantino: serverResponse.leaflet.id,
      device: getAnalyticsDevice(
        isMobileOnly,
        isTablet || isIPad13,
        isDesktop && !isIPad13
      ),
      ip_address: null,
      unique_id: getAnalyticsUniqueId()
    });
  };

  if (clicked) return null;

  return (
    <div
      className=""
      style={{
        position: "absolute",
        bottom: 0,
        width: "100vw",
        height: "100vh",
        margin: "auto",
        backgroundColor: "rgba(90, 197, 243, 0.5)",
        right: 0,
        left: 0,
        zIndex: 11
      }}
    >
      <div
        className="container"
        style={{ position: "absolute", left: 0, right: 0, bottom: 0 }}
      >
        <div className="row">
          <div
            className="col-12 p-5"
            style={{
              backgroundColor: "rgb(90, 197, 243)",
              position: "relative",
              bottom: 0
            }}
          >
            <p>
              Questo sito fa uso di cookie per migliorare l’esperienza di
              navigazione degli utenti e per raccogliere informazioni
              sull’utilizzo del sito stesso. Utilizziamo sia cookie tecnici sia
              cookie di parti terze per inviare messaggi promozionali sulla base
              dei comportamenti degli utenti. Può conoscere i dettagli
              consultando la nostra
              <a
                style={{ color: "#ffdd00", fontWeight: 700 }}
                href="https://www.iperbimbo.it/privacy/"
                rel="noopener noreferrer"
                target="_blank"
              >
                {" "}
                privacy policy qui
              </a>
              . Proseguendo nella navigazione si accetta l’uso dei cookie; in
              caso contrario è possibile abbandonare il sito.
            </p>
            <div className="row">
              <div className="col-12 text-right">
                <button
                  className="btn"
                  style={{ backgroundColor: "#ffdd00" }}
                  onClick={() => {
                    const video_player = document.getElementById(
                      "video_on_page"
                    );
                    if (video_player !== null) {
                      video_player.play();
                    }
                    setCookiesBrowser([
                      {
                        name: "tecnici",
                        value: "true",
                        description:
                          language[defaultLanguage].cookie_detail_tech,
                        expires: new Date().setDate(new Date().getDate() + 30)
                      },
                      {
                        name: "statistiche",
                        value: "true",
                        description:
                          language[defaultLanguage].cookie_detail_stats,
                        expires: new Date().setDate(new Date().getDate() + 30)
                      }
                    ]);

                    let tempVisit = sendVisit();
                    if (tempVisit) {
                      visitAnaliticsVisit();
                    }
                    setClicked(true);
                  }}
                >
                  Continua
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBannerIP;
